/**
 * PWA-UPDATE-1 / TT-HIERARCHY-3 Slice 0 — which build is this browser actually running?
 *
 * Shown in the app footer (components/common/SocialFooter, rendered by all six shells) and set on
 * `window.__aisistooBuild` by swUpdate.ts. It exists because "did my update actually reach that
 * phone?" was previously unanswerable without DevTools and a chunk-hash comparison — and now that
 * updates arrive on their own, that is the question both support and every deploy verification turn
 * on.
 *
 * `__BUILD_ID__` is injected by vite.config.ts from the git short hash at build time, so shipping a
 * version costs nothing and cannot drift from what was actually built. The `typeof` guard keeps this
 * importable from plain tsx/node contexts (the probes), where no bundler define exists.
 *
 * `server/scripts/pwaupdate1-probe.mjs` rewrites this file to build two distinguishable versions of
 * the app, then restores it with `git checkout --`. If you ever find it holding 'PROBE-BUILD-A' or
 * 'PROBE-BUILD-B' in the working tree, a probe run was interrupted — restore it from git.
 */
declare const __BUILD_ID__: string;

export const BUILD_MARKER: string =
  typeof __BUILD_ID__ !== 'undefined' ? __BUILD_ID__ : 'dev';
